export default __webpack_public_path__ + "static/media/bsi.d1221dbd.svg";